import { render, staticRenderFns } from "./growthBottom.vue?vue&type=template&id=41abca37&scoped=true"
import script from "./growthBottom.vue?vue&type=script&lang=js"
export * from "./growthBottom.vue?vue&type=script&lang=js"
import style0 from "./growthBottom.vue?vue&type=style&index=0&id=41abca37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41abca37",
  null
  
)

export default component.exports